import { useFetch } from "../utils/use-fetch";

const getNews = async context => {
  const { req } = context;
  const baseUrl = req ? `${req.protocol}://${req.get("Host")}` : "";
  const { GET } = useFetch("news", baseUrl + "/api/news");
  const news = await GET();
  return news;
};

export { getNews };
